var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 16,
    viewBox: "0 0 51 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1943 0.545983L49.8761 11.0784C51.3746 11.8064 51.3746 12.9835 49.8761 13.7038L46.2731 15.454C44.7745 16.182 42.3512 16.182 40.8686 15.454L25.5 7.98838L10.1315 15.454C8.63286 16.182 6.20959 16.182 4.72694 15.454L1.12395 13.7038C-0.374646 12.9758 -0.374646 11.7986 1.12395 11.0784L22.8057 0.545983C24.2724 -0.181993 26.6957 -0.181993 28.1943 0.545983Z",
    fill: "#9C9F9F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollUp);
export default __webpack_public_path__ + "static/media/scroll-up.d0c8edef8c252704b2ea2bdfe4e0ca65.svg";
export { ForwardRef as ReactComponent };